import { purry } from './purry';
export function merge() {
    return purry(_merge, arguments);
}
function _merge(a, b) {
    return Object.assign({}, a, b);
}
